module.exports = __webpack_public_path__ + "static/media/02_FRMS-2.3-H-10 1.022907e9.svg";